import React from 'react';

type SvgProps = {
    color?: string;
    size?: number;
};

const Kommunale_Mülleimer_Icon: React.FC<SvgProps> = ({ color = "white", size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M96.6673 20L103.334 26.6667H126.667V40H33.334V26.6667H56.6673L63.334 20H96.6673ZM53.334 140C46.0007 140 40.0007 134 40.0007 126.667V46.6667H120.001V126.667C120.001 134 114.001 140 106.667 140H53.334Z" fill={color} fillOpacity="0.8" />
    </svg>




);

export default Kommunale_Mülleimer_Icon;
